import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  arquitec:TreeNode[];
  selectedNode: TreeNode;

  constructor() { }

  ngOnInit() {
    this.getArquitec();
  }

  getArquitec(){
    this.arquitec = [{
      label: 'Projecto',

      children: [
          {
              label: 'app',
              data: 'Sección principal donde desarrollaremos nuestro código.',

              icon: "fa-regular fa-folder-open",
              children: [
                {
                  label: 'core',

                  icon: "fa-regular fa-folder-open",
                  data: ' El núcleo de la aplicación, todos los servicios, interceptores, guards, el módulo principal y el app.component además de algunos componentes que siempre se van a renderizar como la topbar o el menú van bajo esta carpeta',
                  children: [
                    {
                      label: 'modules',
                      icon: "fa-regular fa-folder-open",
                      data: ' La carpeta donde incluiremos los módulos de la aplicación los cuales utilizaremos recursivamente. Se han creado dos: El Init de angular, donde se incluyen modulos básicos de angular. Y el init de primeng donde se incluyen todos los modulos de primeng para no tener que importarlo en cada modulo nuevo que creemos.'
                    },
                    {
                      label: 'services',
                      icon: "fa-regular fa-folder-open",
                      data: 'Fuentes de la app.'
                    },
                    {
                      label: 'login',
                      icon: "fa-regular fa-folder-open",
                      data: 'Pantalla de login y auth service.'
                    },
                    {
                      label: 'guards',
                      icon: "fa-regular fa-folder-open",
                      data: 'Guards de la aplicación, Ej: restringir acceso a componentes por si tiene token o no el usuario.'
                    },
                    {
                      label: 'interceptors',
                      icon: "fa-regular fa-folder-open",
                      data: 'Interceptores HTTP, sirven para que cada llamada AJAX pase por estos (Se pueden añadir de otros tipos). Ej: Jwt, añade token. Error: Revisa los errores para realizar acciones de "No authorize" u otras.'
                    },
                  ]
                },
                {
                  label: 'mocks',

                  icon: "fa-regular fa-folder-open",
                  data: 'Mocks para realizar el testing de Karma.',

                },
                {
                  label: 'shared',

                  data: 'Paginas de error, de error 401 no autorizado...Páginas estáticas.',
                  icon: "fa-regular fa-folder-open",
                  children: [
                    {
                      label: 'components',
                      icon: "fa-regular fa-folder-open",
                      data: 'Vistas de nuestra aplicación. Puede ser desde una pantalla completa, a pequeñas secciones de una o varias pantallas.'
                    },
                    {
                      label: 'directives',
                      icon: "fa-regular fa-folder-open",
                      data: 'Directivas de la app.'
                    },
                    {
                      label: 'models',
                      icon: "fa-regular fa-folder-open",
                      data: 'Modelos/DTO de la app. En angular en vez de DTO se escribe "ClassNameModel" como nombre de la clase y "class-name.model.ts" como nombre de archivo.'
                    },
                    {
                      label: 'pipes',
                      icon: "fa-regular fa-folder-open",
                      data: 'Pipes de transformación de datos de la app.'
                    },
                    {
                      label: 'utilities',
                      icon: "fa-regular fa-folder-open",
                      data: 'El archivo utils.ts contiene funciones (helpers) las cuáles utilizaremos en diferentes componentes. Incluyen funciones para reiniciar formularios, seleccionar la hora y minutos de un timespan, transformar a date las propiedades que llegan del back sin el formato correcto de un objeto u array, validaciones de formularios de pdf, de tamaño máximo de fichero, progreso de envío de datos...'
                    },
                  ]
                },
              ]
          },
          {
              label: 'assets',

              icon: "fa-regular fa-folder-open",
              children: [
                {
                  label: 'layout',

                  icon: "fa-regular fa-folder-open",
                  children: [
                    {
                      label: 'css',
                      icon: "fa-regular fa-folder-open",
                      data: 'Css y Scss utilizados en la applicación.'
                    },
                    {
                      label: 'fonts',
                      icon: "fa-regular fa-folder-open",
                      data: 'Fuentes de la app.'
                    },
                    {
                      label: 'images',
                      icon: "fa-regular fa-folder-open",
                      data: 'Imágenes tipo png, svg...'
                    },
                  ]
                },
                {
                  label: 'pages',
                  icon: "fa-regular fa-folder-open",
                  data: 'Páginas de error, de error 401 no autorizado...Páginas estáticas.'
                },
              ]
          },
          {
              label: 'environments',

              icon: "fa-regular fa-folder-open",
              children: [
                  {
                      label: 'debug (environment.ts)',
                      icon: "fa-regular fa-folder-open",
                      data: 'Se usa cuando compila en desarrollo.'

                  },
                  {
                      label: 'dev (environment.dev.ts)',
                      icon: "fa-regular fa-folder-open",
                      data: 'Se usa cuando se despliega en pruebas.'
                  },
                  {
                      label: 'prod (environment.ts) ',
                      icon: "fa-regular fa-folder-open",
                      data: 'Se usa cuando se despliega en producción.'
                  }
              ]
          }
      ]
    }];
  }

  // onNodeSelect(event){
  //   console.log(event);

  //   this.getMessage(event.node.data);
  // }

  // getMessage(msg : string){
  //   this.msg.showInfo(msg);
  // }
}
